import { render } from "./bargaining_record.vue?vue&type=template&id=c1f706e8&scoped=true&ts=true"
import script from "./bargaining_record.vue?vue&type=script&lang=ts"
export * from "./bargaining_record.vue?vue&type=script&lang=ts"

import "./bargaining_record.vue?vue&type=style&index=0&id=c1f706e8&scoped=true&lang=css"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1f706e8"]])

export default __exports__